import { Injectable } from "@angular/core";
import { ApiService } from "../../../services/api/api.service";
import { UserInfoService } from "../../../services/user-info.service";
import { Observable } from "rxjs";
import { NotificationCountDto, NotificationFilterBody, NotificationListModelsDto } from "../models/notification.models";
import { FilterSearchResultDto } from "src/app/models/filter.model";

@Injectable({
	providedIn: "root",
})
export class NotificationDataService {
	agentId: string | undefined;
	userId: number | undefined;

	constructor(
		private apiService: ApiService,
		private userInfoService: UserInfoService
	) {
		this.userInfoService.userId$.subscribe({
			next: (res) => {
				this.userId = res;
			},
		});

		this.userInfoService.agentId$.subscribe({
			next: (res) => {
				this.agentId = res;
			},
		});
	}

	loadCount(): Observable<NotificationCountDto> {
		const url = `/agents/${this.agentId}/notifications/users/${this.userId}/unread`;
		return this.apiService.httpGet<NotificationCountDto>(url);
	}

	loadUserNotificationList(
		page: number,
		search: string | undefined = "",
		body?: NotificationFilterBody,
		order = "ASC"
	): Observable<NotificationListModelsDto> {
		const url = `/agents/${this.agentId}/notifications/users/${this.userId}/filter?page_number=${page}&per_page=20&order=${order}&field=PRIORITY&search=${search}`;
		return this.apiService.httpPost<NotificationListModelsDto>(url, body);
	}

	loadNotificationFilter(): Observable<any> {
		const url = `/agents/${this.agentId}/notifications/filter`;
		return this.apiService.httpGet<any>(url);
	}

	setReadStatus(id: number): Observable<void> {
		const url = `/agents/${this.agentId}/notifications/${id}/users/${this.userId}`;
		return this.apiService.httpPatch<void>(url);
	}

	deleteItemNotification(id: number): Observable<void> {
		const url = `/agents/${this.agentId}/notifications/${id}/users/${this.userId}`;
		return this.apiService.httpDelete<void>(url);
	}

	deleteAllNotification(): Observable<void> {
		const url = `/agents/${this.agentId}/notifications/users/${this.userId}`;
		return this.apiService.httpDelete<void>(url);
	}

	loadSearchList(data: any): Observable<FilterSearchResultDto> {
		const url = `/agents/${this.agentId}/notifications/filter/list?page_number=0&per_page=10`;
		return this.apiService.httpPost<FilterSearchResultDto>(url, data);
	}

	readAllNotifications() {
		const url = `/agents/${this.agentId}/notifications/users/${this.userId}/read_all`;
		return this.apiService.httpGet<void>(url);
	}
}
